module.exports = __webpack_public_path__ + "img/MESTNA OBCINA NOVA GORICA.2a9880a7.png";